import React from 'react';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Checkbox } from 'antd';

import { CommonTnc } from '../CommonTncLI';

export const AgreementCheckboxLI = (props: { onChange: (e: CheckboxChangeEvent) => void }) => {
  return (
    <Checkbox onChange={props.onChange} style={{ fontSize: '17px' }}>
      <CommonTnc />
    </Checkbox>
  );
};
